// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Conversations-module__font-s-10___zR7LV {
  font-size: 10px !important;
}

.Conversations-module__font-s-12___EsMQj {
  font-size: 12px !important;
}

.Conversations-module__font-s-13___XKZwA {
  font-size: 13px !important;
}

.Conversations-module__font-s-14___zla4E {
  font-size: 14px !important;
}

.Conversations-module__font-s-15___JOhPN {
  font-size: 15px !important;
}

.Conversations-module__font-s-16___WuGNS {
  font-size: 16px !important;
}

.Conversations-module__font-s-18___rhgfK {
  font-size: 18px !important;
}

.Conversations-module__font-s-20___P4doB {
  font-size: 20px !important;
}

.Conversations-module__font-s-22___QrTUK {
  font-size: 22px !important;
}

.Conversations-module__font-s-28___GBdxn {
  font-size: 28px !important;
}

.Conversations-module__font-w-400___DLsSx {
  font-weight: 400 !important;
}

.Conversations-module__font-w-500___nqhrN {
  font-weight: 500 !important;
}

.Conversations-module__font-w-600___Cjn6W {
  font-weight: 600 !important;
}

.Conversations-module__font-w-700___VTbGy {
  font-weight: 700 !important;
}

.Conversations-module__p-5___mf193 {
  padding: 5px !important;
}

.Conversations-module__p-12___FyF1H {
  padding: 12px !important;
}

.Conversations-module__p-16___xTFrZ {
  padding: 16px !important;
}

.Conversations-module__p-30___JMA2o {
  padding: 30px !important;
}

.Conversations-module__p-b-0____qLV9 {
  padding-bottom: 0 !important;
}

.Conversations-module__p-b-5___bQwJo {
  padding-bottom: 5px !important;
}

.Conversations-module__p-b-10___gpMJx {
  padding-bottom: 10px !important;
}

.Conversations-module__p-b-12___pM2MD {
  padding-bottom: 12px !important;
}

.Conversations-module__p-b-16___Jin9_ {
  padding-bottom: 16px !important;
}

.Conversations-module__p-b-18___lyQzW {
  padding-bottom: 18px !important;
}

.Conversations-module__p-b-20___TIADp {
  padding-bottom: 20px !important;
}

.Conversations-module__p-b-25___F0goB {
  padding-bottom: 25px !important;
}

.Conversations-module__p-b-30___Np_37 {
  padding-bottom: 30px !important;
}

.Conversations-module__p-b-50___dRyQV {
  padding-bottom: 50px !important;
}

.Conversations-module__p-t-0___hGh4v {
  padding-top: 0 !important;
}

.Conversations-module__p-t-12___QGC3U {
  padding-top: 12px !important;
}

.Conversations-module__p-t-16___PTGGZ {
  padding-top: 16px !important;
}

.Conversations-module__p-t-18___aGOTw {
  padding-top: 18px !important;
}

.Conversations-module__p-t-20___QLgwK {
  padding-top: 20px !important;
}

.Conversations-module__p-t-30___PkHf3 {
  padding-top: 30px !important;
}

.Conversations-module__p-t-40___CUjzd {
  padding-top: 40px !important;
}

.Conversations-module__p-t-50___uy0Gu {
  padding-top: 50px !important;
}

.Conversations-module__p-l-20___lDinB {
  padding-left: 20px !important;
}

.Conversations-module__p-l-30___fAQo7 {
  padding-left: 30px !important;
}

.Conversations-module__p-l-40___wG7Ur {
  padding-left: 40px !important;
}

.Conversations-module__p-r-16___VLVgi {
  padding-right: 16px !important;
}

.Conversations-module__p-r-20___WAJqT {
  padding-right: 20px !important;
}

.Conversations-module__p-r-30___Wlj5n {
  padding-right: 30px !important;
}

.Conversations-module__p-r-50___vUCwc {
  padding-right: 50px !important;
}

.Conversations-module__p-r-60___y2_gm {
  padding-right: 60px !important;
}

.Conversations-module__m-b-1___O1f81 {
  margin-bottom: 1px !important;
}

.Conversations-module__m-b-2___kt6zl {
  margin-bottom: 2px !important;
}

.Conversations-module__m-b-6___QHfWC {
  margin-bottom: 6px !important;
}

.Conversations-module__m-b-8___Y12hq {
  margin-bottom: 8px !important;
}

.Conversations-module__m-b-10___ju_cC {
  margin-bottom: 10px !important;
}

.Conversations-module__m-b-14___yh79v {
  margin-bottom: 14px !important;
}

.Conversations-module__m-b-16___F7PC0 {
  margin-bottom: 16px !important;
}

.Conversations-module__m-b-20___cDypv {
  margin-bottom: 20px !important;
}

.Conversations-module__m-b-22___EwzEd {
  margin-bottom: 22px !important;
}

.Conversations-module__m-b-24___RIh9u {
  margin-bottom: 24px !important;
}

.Conversations-module__m-b-30___ueepq {
  margin-bottom: 30px !important;
}

.Conversations-module__m-b-32___vPvre {
  margin-bottom: 32px !important;
}

.Conversations-module__m-b-40___AsWyg {
  margin-bottom: 40px !important;
}

.Conversations-module__m-t-2___JcLKE {
  margin-top: 2px !important;
}

.Conversations-module__m-t-3___PIkgv {
  margin-top: 3px !important;
}

.Conversations-module__m-t-4___jk5Ty {
  margin-top: 4px !important;
}

.Conversations-module__m-t-5___QhH66 {
  margin-top: 5px !important;
}

.Conversations-module__m-t-8___E9WYW {
  margin-top: 8px !important;
}

.Conversations-module__m-t-10___q8msH {
  margin-top: 10px !important;
}

.Conversations-module__m-t-15___uGagO {
  margin-top: 15px !important;
}

.Conversations-module__m-t-16___SCC9P {
  margin-top: 16px !important;
}

.Conversations-module__m-t-20___gwhBe {
  margin-top: 20px !important;
}

.Conversations-module__m-t-22___nOiK0 {
  margin-top: 22px !important;
}

.Conversations-module__m-t-30___chiBN {
  margin-top: 30px !important;
}

.Conversations-module__m-t-32___IZOR4 {
  margin-top: 32px !important;
}

.Conversations-module__m-l-auto___kWOhk {
  margin-left: auto !important;
}

.Conversations-module__m-l-4___yZxYI {
  margin-left: 4px !important;
}

.Conversations-module__m-l-5___ylUd4 {
  margin-left: 5px !important;
}

.Conversations-module__m-l-6___mLl00 {
  margin-left: 6px !important;
}

.Conversations-module__m-l-8___uLaCG {
  margin-left: 8px !important;
}

.Conversations-module__m-l-10___VKmVG {
  margin-left: 10px !important;
}

.Conversations-module__m-l-16___iYRdy {
  margin-left: 16px !important;
}

.Conversations-module__m-l-20___oXKZY {
  margin-left: 20px !important;
}

.Conversations-module__m-l-24___BUR81 {
  margin-left: 24px !important;
}

.Conversations-module__m-l-30___xOcX9 {
  margin-left: 30px !important;
}

.Conversations-module__m-l-35___x64ru {
  margin-left: 35px !important;
}

.Conversations-module__m-l-40___sOIq7 {
  margin-left: 40px !important;
}

.Conversations-module__m-r-8___pWy6D {
  margin-right: 8px !important;
}

.Conversations-module__m-r-10___IDL42 {
  margin-right: 10px !important;
}

.Conversations-module__m-r-16___ULTVm {
  margin-right: 16px !important;
}

.Conversations-module__m-r-20___AVG2K {
  margin-right: 20px !important;
}

.Conversations-module__m-r-24___XIbsU {
  margin-right: 24px !important;
}

.Conversations-module__m-r-30___tA303 {
  margin-right: 30px !important;
}

.Conversations-module__m-r-40___goSH_ {
  margin-right: 40px !important;
}

.Conversations-module__border-r-3___zSnUA {
  border-radius: 3px !important;
}

.Conversations-module__border-r-4___YjjfE {
  border-radius: 4px !important;
}

.Conversations-module__border-r-6___ESxqB {
  border-radius: 6px !important;
}

.Conversations-module__border-r-10____2eOf {
  border-radius: 10px !important;
}

.Conversations-module__border-r-12___yNkHb {
  border-radius: 12px !important;
}

.Conversations-module__border-r-16___T7SVt {
  border-radius: 16px !important;
}

.Conversations-module__border-r-50___HNoRH {
  border-radius: 50% !important;
}

.Conversations-module__primary-border___O3MeY {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Conversations-module__primary-border-b___OgEWv {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Conversations-module__primary-border-t___xgAIf {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Conversations-module__primary-border-l___UOjAX {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Conversations-module__primary-border-r___ZKWjN {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Conversations-module__secondary-border___iSqsd {
  border: 1px solid #637768;
}

.Conversations-module__secondary-border-b___dxk5n {
  border-bottom: 1px solid #637768;
}

.Conversations-module__secondary-border-t___tqrR0 {
  border-top: 1px solid #637768;
}

.Conversations-module__secondary-border-l___cGhcl {
  border-left: 1px solid #637768;
}

.Conversations-module__secondary-border-r___YxbnX {
  border-right: 1px solid #637768;
}

.Conversations-module__gap-0___R9kFz {
  gap: 0 !important;
}

.Conversations-module__gap-2___CuDgy {
  gap: 2px !important;
}

.Conversations-module__gap-4___Ayr53 {
  gap: 4px !important;
}

.Conversations-module__gap-5____r1IW {
  gap: 5px !important;
}

.Conversations-module__gap-6___eMpE8 {
  gap: 6px !important;
}

.Conversations-module__gap-8___nkq8W {
  gap: 8px !important;
}

.Conversations-module__gap-10___IUQ68 {
  gap: 10px !important;
}

.Conversations-module__gap-12___KwZyF {
  gap: 12px !important;
}

.Conversations-module__gap-14___C9W0n {
  gap: 14px !important;
}

.Conversations-module__gap-16___G1Z2L {
  gap: 16px !important;
}

.Conversations-module__gap-18___b8rJ5 {
  gap: 18px !important;
}

.Conversations-module__gap-20___Djwlf {
  gap: 20px !important;
}

.Conversations-module__gap-24___gqvEt {
  gap: 24px !important;
}

.Conversations-module__gap-26___XnQwc {
  gap: 26px !important;
}

.Conversations-module__gap-30___Ia1aP {
  gap: 30px !important;
}

.Conversations-module__gap-32___B621t {
  gap: 32px !important;
}

.Conversations-module__gap-40___KzFC5 {
  gap: 40px !important;
}

.Conversations-module__gap-50___hESmC {
  gap: 50px !important;
}

.Conversations-module__flex-1___ff3MR {
  flex: 1;
}

.Conversations-module__flex-none___wM2rI {
  flex: none !important;
}

.Conversations-module__flex-column___nY6Y0 {
  display: flex;
  flex-direction: column !important;
}

.Conversations-module__flex-row___UbxLX {
  display: flex;
  flex-direction: row !important;
}

.Conversations-module__vertically-centered___vJWh_ {
  display: flex;
  align-items: center !important;
}

.Conversations-module__horizontally-centered___dEjQr {
  display: flex;
  justify-content: center !important;
}

.Conversations-module__horizontally-end___DzrY_ {
  display: flex;
  justify-content: end !important;
}

.Conversations-module__vertically-start___nPZqn {
  display: flex;
  align-items: start !important;
}

.Conversations-module__space-between___oeX06 {
  display: flex;
  justify-content: space-between !important;
}

.Conversations-module__flex-wrap___EvTdt {
  flex-wrap: wrap !important;
}

.Conversations-module__height-100___obSqW {
  height: 100%;
}

.Conversations-module__width-50___AsLP6 {
  width: 50% !important;
}

.Conversations-module__width-100___ZD77w {
  width: 100%;
}

.Conversations-module__cursor-pointer___YzQpq {
  cursor: pointer;
}

.Conversations-module__cursor-not-allowed___swr_L {
  cursor: not-allowed !important;
}

.Conversations-module__absolute-centered___bDvhw {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Conversations-module__absolute___DO20N {
  position: absolute;
}

.Conversations-module__relative___DKXzQ {
  position: relative;
}

.Conversations-module__fixed___uaXiw {
  position: fixed;
}

.Conversations-module__visible___z02uR {
  opacity: 1;
}

.Conversations-module__invisible___Mkore {
  opacity: 0;
}

.Conversations-module__col-90___fdEgi {
  width: 90% !important;
}

.Conversations-module__col-auto___lPXhu {
  width: auto !important;
}

.Conversations-module__medical-tabs___bwmm4 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Conversations-module__medical-table-new___d4jff {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Conversations-module__medical-table-new___d4jff:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Conversations-module__medical-table-new___d4jff::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Conversations-module__medical-table-new___d4jff::-webkit-scrollbar-track {
  display: none;
}
.Conversations-module__medical-table-new___d4jff.Conversations-module__no-pagination___ZITzQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Conversations-module__medical-table-new___d4jff.Conversations-module__no-pagination___ZITzQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Conversations-module__medical-table-new___d4jff.Conversations-module__no-pagination___ZITzQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Conversations-module__medical-table-new___d4jff.Conversations-module__no-pagination___ZITzQ::-webkit-scrollbar-track {
  display: none;
}

.Conversations-module__medical-table-empty___mZkrb {
  padding: 14px 40px !important;
}

.Conversations-module__icon-btn___l1D8c {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Conversations-module__search-icon___dQ6fy {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Conversations-module__disable-select___TkLri {
  user-select: none;
}

.Conversations-module__break-word___yKsob {
  word-break: break-word;
}

.Conversations-module__popup-clear-btn___x_UQ5 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Conversations-module__scroll-m-b-20___gMImd {
  scroll-margin-bottom: 20px;
}

.Conversations-module__header___C9ibi {
  color: #375844;
}

.Conversations-module__checkbox___pb6Cq > div {
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/LinkedConversationsModule/Conversations/Conversations.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA1pBE;EACE,0BAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  color: get-color(greenNew, dark);\n}\n\n.checkbox {\n  & > div {\n    font-size: 12px !important;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Conversations-module__font-s-10___zR7LV`,
	"fontS12": `Conversations-module__font-s-12___EsMQj`,
	"fontS13": `Conversations-module__font-s-13___XKZwA`,
	"fontS14": `Conversations-module__font-s-14___zla4E`,
	"fontS15": `Conversations-module__font-s-15___JOhPN`,
	"fontS16": `Conversations-module__font-s-16___WuGNS`,
	"fontS18": `Conversations-module__font-s-18___rhgfK`,
	"fontS20": `Conversations-module__font-s-20___P4doB`,
	"fontS22": `Conversations-module__font-s-22___QrTUK`,
	"fontS28": `Conversations-module__font-s-28___GBdxn`,
	"fontW400": `Conversations-module__font-w-400___DLsSx`,
	"fontW500": `Conversations-module__font-w-500___nqhrN`,
	"fontW600": `Conversations-module__font-w-600___Cjn6W`,
	"fontW700": `Conversations-module__font-w-700___VTbGy`,
	"p5": `Conversations-module__p-5___mf193`,
	"p12": `Conversations-module__p-12___FyF1H`,
	"p16": `Conversations-module__p-16___xTFrZ`,
	"p30": `Conversations-module__p-30___JMA2o`,
	"pB0": `Conversations-module__p-b-0____qLV9`,
	"pB5": `Conversations-module__p-b-5___bQwJo`,
	"pB10": `Conversations-module__p-b-10___gpMJx`,
	"pB12": `Conversations-module__p-b-12___pM2MD`,
	"pB16": `Conversations-module__p-b-16___Jin9_`,
	"pB18": `Conversations-module__p-b-18___lyQzW`,
	"pB20": `Conversations-module__p-b-20___TIADp`,
	"pB25": `Conversations-module__p-b-25___F0goB`,
	"pB30": `Conversations-module__p-b-30___Np_37`,
	"pB50": `Conversations-module__p-b-50___dRyQV`,
	"pT0": `Conversations-module__p-t-0___hGh4v`,
	"pT12": `Conversations-module__p-t-12___QGC3U`,
	"pT16": `Conversations-module__p-t-16___PTGGZ`,
	"pT18": `Conversations-module__p-t-18___aGOTw`,
	"pT20": `Conversations-module__p-t-20___QLgwK`,
	"pT30": `Conversations-module__p-t-30___PkHf3`,
	"pT40": `Conversations-module__p-t-40___CUjzd`,
	"pT50": `Conversations-module__p-t-50___uy0Gu`,
	"pL20": `Conversations-module__p-l-20___lDinB`,
	"pL30": `Conversations-module__p-l-30___fAQo7`,
	"pL40": `Conversations-module__p-l-40___wG7Ur`,
	"pR16": `Conversations-module__p-r-16___VLVgi`,
	"pR20": `Conversations-module__p-r-20___WAJqT`,
	"pR30": `Conversations-module__p-r-30___Wlj5n`,
	"pR50": `Conversations-module__p-r-50___vUCwc`,
	"pR60": `Conversations-module__p-r-60___y2_gm`,
	"mB1": `Conversations-module__m-b-1___O1f81`,
	"mB2": `Conversations-module__m-b-2___kt6zl`,
	"mB6": `Conversations-module__m-b-6___QHfWC`,
	"mB8": `Conversations-module__m-b-8___Y12hq`,
	"mB10": `Conversations-module__m-b-10___ju_cC`,
	"mB14": `Conversations-module__m-b-14___yh79v`,
	"mB16": `Conversations-module__m-b-16___F7PC0`,
	"mB20": `Conversations-module__m-b-20___cDypv`,
	"mB22": `Conversations-module__m-b-22___EwzEd`,
	"mB24": `Conversations-module__m-b-24___RIh9u`,
	"mB30": `Conversations-module__m-b-30___ueepq`,
	"mB32": `Conversations-module__m-b-32___vPvre`,
	"mB40": `Conversations-module__m-b-40___AsWyg`,
	"mT2": `Conversations-module__m-t-2___JcLKE`,
	"mT3": `Conversations-module__m-t-3___PIkgv`,
	"mT4": `Conversations-module__m-t-4___jk5Ty`,
	"mT5": `Conversations-module__m-t-5___QhH66`,
	"mT8": `Conversations-module__m-t-8___E9WYW`,
	"mT10": `Conversations-module__m-t-10___q8msH`,
	"mT15": `Conversations-module__m-t-15___uGagO`,
	"mT16": `Conversations-module__m-t-16___SCC9P`,
	"mT20": `Conversations-module__m-t-20___gwhBe`,
	"mT22": `Conversations-module__m-t-22___nOiK0`,
	"mT30": `Conversations-module__m-t-30___chiBN`,
	"mT32": `Conversations-module__m-t-32___IZOR4`,
	"mLAuto": `Conversations-module__m-l-auto___kWOhk`,
	"mL4": `Conversations-module__m-l-4___yZxYI`,
	"mL5": `Conversations-module__m-l-5___ylUd4`,
	"mL6": `Conversations-module__m-l-6___mLl00`,
	"mL8": `Conversations-module__m-l-8___uLaCG`,
	"mL10": `Conversations-module__m-l-10___VKmVG`,
	"mL16": `Conversations-module__m-l-16___iYRdy`,
	"mL20": `Conversations-module__m-l-20___oXKZY`,
	"mL24": `Conversations-module__m-l-24___BUR81`,
	"mL30": `Conversations-module__m-l-30___xOcX9`,
	"mL35": `Conversations-module__m-l-35___x64ru`,
	"mL40": `Conversations-module__m-l-40___sOIq7`,
	"mR8": `Conversations-module__m-r-8___pWy6D`,
	"mR10": `Conversations-module__m-r-10___IDL42`,
	"mR16": `Conversations-module__m-r-16___ULTVm`,
	"mR20": `Conversations-module__m-r-20___AVG2K`,
	"mR24": `Conversations-module__m-r-24___XIbsU`,
	"mR30": `Conversations-module__m-r-30___tA303`,
	"mR40": `Conversations-module__m-r-40___goSH_`,
	"borderR3": `Conversations-module__border-r-3___zSnUA`,
	"borderR4": `Conversations-module__border-r-4___YjjfE`,
	"borderR6": `Conversations-module__border-r-6___ESxqB`,
	"borderR10": `Conversations-module__border-r-10____2eOf`,
	"borderR12": `Conversations-module__border-r-12___yNkHb`,
	"borderR16": `Conversations-module__border-r-16___T7SVt`,
	"borderR50": `Conversations-module__border-r-50___HNoRH`,
	"primaryBorder": `Conversations-module__primary-border___O3MeY`,
	"primaryBorderB": `Conversations-module__primary-border-b___OgEWv`,
	"primaryBorderT": `Conversations-module__primary-border-t___xgAIf`,
	"primaryBorderL": `Conversations-module__primary-border-l___UOjAX`,
	"primaryBorderR": `Conversations-module__primary-border-r___ZKWjN`,
	"secondaryBorder": `Conversations-module__secondary-border___iSqsd`,
	"secondaryBorderB": `Conversations-module__secondary-border-b___dxk5n`,
	"secondaryBorderT": `Conversations-module__secondary-border-t___tqrR0`,
	"secondaryBorderL": `Conversations-module__secondary-border-l___cGhcl`,
	"secondaryBorderR": `Conversations-module__secondary-border-r___YxbnX`,
	"gap0": `Conversations-module__gap-0___R9kFz`,
	"gap2": `Conversations-module__gap-2___CuDgy`,
	"gap4": `Conversations-module__gap-4___Ayr53`,
	"gap5": `Conversations-module__gap-5____r1IW`,
	"gap6": `Conversations-module__gap-6___eMpE8`,
	"gap8": `Conversations-module__gap-8___nkq8W`,
	"gap10": `Conversations-module__gap-10___IUQ68`,
	"gap12": `Conversations-module__gap-12___KwZyF`,
	"gap14": `Conversations-module__gap-14___C9W0n`,
	"gap16": `Conversations-module__gap-16___G1Z2L`,
	"gap18": `Conversations-module__gap-18___b8rJ5`,
	"gap20": `Conversations-module__gap-20___Djwlf`,
	"gap24": `Conversations-module__gap-24___gqvEt`,
	"gap26": `Conversations-module__gap-26___XnQwc`,
	"gap30": `Conversations-module__gap-30___Ia1aP`,
	"gap32": `Conversations-module__gap-32___B621t`,
	"gap40": `Conversations-module__gap-40___KzFC5`,
	"gap50": `Conversations-module__gap-50___hESmC`,
	"flex1": `Conversations-module__flex-1___ff3MR`,
	"flexNone": `Conversations-module__flex-none___wM2rI`,
	"flexColumn": `Conversations-module__flex-column___nY6Y0`,
	"flexRow": `Conversations-module__flex-row___UbxLX`,
	"verticallyCentered": `Conversations-module__vertically-centered___vJWh_`,
	"horizontallyCentered": `Conversations-module__horizontally-centered___dEjQr`,
	"horizontallyEnd": `Conversations-module__horizontally-end___DzrY_`,
	"verticallyStart": `Conversations-module__vertically-start___nPZqn`,
	"spaceBetween": `Conversations-module__space-between___oeX06`,
	"flexWrap": `Conversations-module__flex-wrap___EvTdt`,
	"height100": `Conversations-module__height-100___obSqW`,
	"width50": `Conversations-module__width-50___AsLP6`,
	"width100": `Conversations-module__width-100___ZD77w`,
	"cursorPointer": `Conversations-module__cursor-pointer___YzQpq`,
	"cursorNotAllowed": `Conversations-module__cursor-not-allowed___swr_L`,
	"absoluteCentered": `Conversations-module__absolute-centered___bDvhw`,
	"absolute": `Conversations-module__absolute___DO20N`,
	"relative": `Conversations-module__relative___DKXzQ`,
	"fixed": `Conversations-module__fixed___uaXiw`,
	"visible": `Conversations-module__visible___z02uR`,
	"invisible": `Conversations-module__invisible___Mkore`,
	"col90": `Conversations-module__col-90___fdEgi`,
	"colAuto": `Conversations-module__col-auto___lPXhu`,
	"medicalTabs": `Conversations-module__medical-tabs___bwmm4`,
	"medicalTableNew": `Conversations-module__medical-table-new___d4jff`,
	"noPagination": `Conversations-module__no-pagination___ZITzQ`,
	"medicalTableEmpty": `Conversations-module__medical-table-empty___mZkrb`,
	"iconBtn": `Conversations-module__icon-btn___l1D8c`,
	"searchIcon": `Conversations-module__search-icon___dQ6fy`,
	"disableSelect": `Conversations-module__disable-select___TkLri`,
	"breakWord": `Conversations-module__break-word___yKsob`,
	"popupClearBtn": `Conversations-module__popup-clear-btn___x_UQ5`,
	"scrollMB20": `Conversations-module__scroll-m-b-20___gMImd`,
	"header": `Conversations-module__header___C9ibi`,
	"checkbox": `Conversations-module__checkbox___pb6Cq`
};
module.exports = ___CSS_LOADER_EXPORT___;
